import React from 'react';
import styles from './TrustBanner.module.scss';

const items = [
  { icon: 'fas fa-bolt', text: 'Instant Delivery' },
  { icon: 'fas fa-users', text: '1M+ Happy Users' },
  { icon: 'fas fa-piggy-bank', text: '₹50M+ Saved' },
  { icon: 'fas fa-shield-alt', text: 'Safe & Secure' },
];

const TrustBanner: React.FC = () => {
  return (
    <section className={styles.trustBanner} aria-label="Trust and features">
      <div className={styles.bannerInner}>
        {items.map((item, index) => (
          <div key={index} className={styles.item}>
            <span className={styles.iconWrap}>
              <i className={item.icon} aria-hidden />
            </span>
            <span className={styles.itemText}>{item.text}</span>
          </div>
        ))}
      </div>
    </section>
  );
};

export default TrustBanner;
